import { render, staticRenderFns } from "./livevideo.vue?vue&type=template&id=c9f9acb2&scoped=true&"
import script from "./livevideo.vue?vue&type=script&lang=js&"
export * from "./livevideo.vue?vue&type=script&lang=js&"
import style0 from "./livevideo.vue?vue&type=style&index=0&id=c9f9acb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f9acb2",
  null
  
)

export default component.exports